import cn from 'classnames';
import PropTypes from 'prop-types';

function LdsButtonGroup({
  dropdownId,
  className,
  children,
  ...rest
}) {
  return (
    <div
      id={dropdownId || null}
      className={cn(
        'lds-button-group',
        className
      )}
      {...rest}
    >
      <div className="lds-button-group-container">
        {children}
      </div>
    </div>
  );
}

function Buttons({
  dropdownId,
  classes,
  split,
  iconName,
  disabled,
  children,
}) {
  return (
    <div className="lds-button-group-buttons">
      {children}
      { dropdownId
        && <div
            className={cn(
              'lds-button',
              classes,
              'p-0'
            )}
            disabled={disabled || null}
          >
            <lds-button-group-toggle
              dropdownId={dropdownId}
              iconName={iconName}
              disabled={disabled || null}
              isSplit={split || null}
            >
            </lds-button-group-toggle>
          </div>
      }
    </div>
  );
}
LdsButtonGroup.Buttons = Buttons;

function Dropdown({ children }) {
  return (
    <div className="lds-button-group-dropdown">
      {children}
    </div>
  );
}
LdsButtonGroup.Dropdown = Dropdown;

LdsButtonGroup.propTypes = {
  dropdownId: PropTypes.string,
};

LdsButtonGroup.Buttons.propTypes = {
  classes: PropTypes.string,
  className: PropTypes.string,
  dropdownId: PropTypes.string,
  iconName: PropTypes.string,
  disabled: PropTypes.bool,
  split: PropTypes.bool,
};
export default LdsButtonGroup;
